// extracted by mini-css-extract-plugin
export var editInput = "_ge-0";
export var editInputCompact = "_ge-2";
export var editInputLarge = "_ge-1";
export var editInputSmall = "_ge-3";